import {
    getPartsAllListRequest,
    getPartsAllRequest,
    getPartsNoAccountAllListRequest,
    getPartsNoAccountAllRequest,
} from '../../../../../services/network/region_services/parts/all';

class CommonPartsAllService {
    async getPartsAllList(payload) {
        return await getPartsAllListRequest(payload);
    }

    async getPartsAll(id) {
        return await getPartsAllRequest(id);
    }

    async getPartsNoAccountList(payload) {
        return await getPartsNoAccountAllListRequest(payload);
    }

    async getPartsNoAccount(id) {
        return await getPartsNoAccountAllRequest(id);
    }
}

export const PartsAllService = new CommonPartsAllService();
